import { Section } from '@shared/components/Section';
import { GradeDePessoas } from '@shared/components/moldes';
import { pessoas, corpoDocente } from '@curso/content/pessoas';

/**
 * Responde: posso confiar em quem está na sala.
 *
 * As cinco titulações juntas são o argumento, não a decoração. Medicina,
 * enfermagem, farmácia e fatores humanos provam que o curso é
 * multiprofissional sem que a página precise afirmar isso.
 */
export function QuemEnsina() {
  return (
    <>
      <Section id="quem-facilita" rotulo="Quem facilita" titulo={corpoDocente.abertura}>
        <p className="prosa mb-9">{corpoDocente.texto}</p>
        <GradeDePessoas pessoas={pessoas} />
      </Section>

      <Section id="um-proposito" rotulo="O conjunto" titulo={corpoDocente.tituloDoFecho}>
        <p className="prosa">{corpoDocente.fecho}</p>
        <p className="prosa mt-5 text-tinta">{corpoDocente.remate}</p>
      </Section>
    </>
  );
}
